module.exports = __webpack_public_path__ + "static/media/dbank2.73567394.png";